export function createRef() {
    var refObject = (function (element) {
        refObject.value = element;
    });
    refObject.value = null;
    return refObject;
}
//# sourceMappingURL=createRef.js.map